import { CardImgOverlay as _CardImgOverlay, CardImgOverlayProps as _CardImgOverlayProps } from "reactstrap";

    export const CardImgOverlay = _CardImgOverlay;
    export type CardImgOverlayProps = _CardImgOverlayProps;
    